export class ConfigMaxSetData {

    public id: number;
    public name: String;
    public categoryId: number;
    public subcategoryId: number;
    public title: String;
    public vmwProductId: number;
    public vmwProductReleaseId: any;
    public publishedDate: Date;
    public statusId: number;
    public comments: String;
    public LastUpdate: Date;
    public UpdatedBy: String;
    public newVersion: boolean;
    public cloneProductId: number;
    public coneProductReleaseId: number;
    public configs: any;
    public approvedAttributes: number;
    public primaryAuthor: String;
    public secondaryAuthor: String;

}



// WEBPACK FOOTER //
// ./src/app/models/configmaxsetdata.ts